import http from './http'

class Notifications {
  unread () {
    return http.get('/notifications/user_notifications/unread_notifications')
  }

  markAllAsRead () {
    return http.put('notifications/user_notifications/mark_all_as_read')
  }

  markAsRead (id) {
    return http.put(`notifications/user_notifications/mark_as_read/${id}`)
  }
}

export default new Notifications()



// WEBPACK FOOTER //
// ./src/services/notifications.js